import path from 'path'

module.exports = {
  i18n: {
    locales: ['default', 'en', 'es', 'fr'],
    defaultLocale: 'default',
    localeDetection: true,
  },
  localePath: path.resolve('./public/locales'),
}